import { Alert } from '@mui/material'
import { TIPI_MESSAGGI } from 'feedback'
import { BaseGridLayout } from 'layout'

const COLORI_AVVISI = {
  [TIPI_MESSAGGI.ERROR]: 'error',
  [TIPI_MESSAGGI.WARNING]: 'warning',
  [TIPI_MESSAGGI.INFO]: 'info',
  [TIPI_MESSAGGI.SUCCESS]: 'success'
}

export default function AvvisiEntita(props) {
  const { avvisi = [] } = props

  if (avvisi.length === 0) return null

  return (
    <BaseGridLayout vertical>
      {avvisi.map(({ key, msg, type }) =>
        <Alert
          key={key}
          elevation={3}
          variant='filled'
          severity={COLORI_AVVISI[type]}
        >
          {msg}
        </Alert>
      )}
    </BaseGridLayout>
  )
}